module.exports = __webpack_public_path__ + "static/img/uidesignmobile.2116eac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/With/uidesignmobile.png
// module id = lk6v
// module chunks = 0